"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var genCollapseMotion = function genCollapseMotion(token) {
  return _defineProperty({}, token.componentCls, _defineProperty(_defineProperty({}, "".concat(token.antCls, "-motion-collapse-legacy"), {
    overflow: 'hidden',
    '&-active': {
      transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
    }
  }), "".concat(token.antCls, "-motion-collapse"), {
    overflow: 'hidden',
    transition: "height ".concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, ",\n        opacity ").concat(token.motionDurationMid, " ").concat(token.motionEaseInOut, " !important")
  }));
};
var _default = exports["default"] = genCollapseMotion;